import React, { ReactElement, useContext, useState } from 'react';
import { Button } from '@wds/button';
import { T, defineMessages } from '@sm/intl';
import { generateMetricsAttribute } from '@sm/metrics';
import SeatRequestModal from '../../../../SeatRequestModal';
import HeaderContext from '../../HeaderContext';

export const COPY = defineMessages({
  SEAT_REQUEST: {
    id: 'ButtonSeatUpgrade.SeatRequest',
    defaultMessage: 'Request power seat',
    description:
      '[Type: Label][Vis.: high] - This is a button for users to request a seat upgrade.',
  },
});

const ButtonUpgradeSeat = (): ReactElement => {
  const [showModal, setShowModal] = useState(false);

  const { pageURL, pageName } = useContext(HeaderContext);
  return (
    <>
      <Button
        color="alt"
        size="sm"
        disabled={showModal}
        onClick={() => {
          setShowModal(true);
        }}
        data-sm-metrics={generateMetricsAttribute({
          data: {
            url: pageURL,
            pageName,
            amplitudeEvent: 'header clicked cta',
            ctaName: 'upgrade',
          },
        })}
      >
        <T desc={COPY.SEAT_REQUEST} />
      </Button>
      <SeatRequestModal
        show={showModal}
        onClose={() => setShowModal(false)}
        sourceCategoryKey="global_header"
      />
    </>
  );
};

export default ButtonUpgradeSeat;
